"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initConsent = void 0;
const init_hubspot_1 = require("./init-hubspot");
const init_segment_next_1 = require("./init-segment-next");
const subscribers_1 = require("./subscribers");
const initConsent = ({ portalId, writeKey, amplitudeKey, env, isReady = () => true, }) => {
    (0, init_hubspot_1.initHubspot)({ portalId, respectDNT: true });
    const analytics = (0, init_segment_next_1.initSegmentNext)(writeKey, undefined, isReady);
    (0, subscribers_1.syncGoogleAdsConsent)();
    (0, subscribers_1.syncAmplitudeConsent)({ amplitudeKey, env, analytics });
};
exports.initConsent = initConsent;
